import React from "react";
import { Link } from "react-router-dom";

const MENTION_RE = /(^|\s)@([A-Za-z0-9_]{2,30})\b/g;

/**
 * Splits a string into React fragments, converting @-mentions into Links to
 * `/u/:username`. Anything not a mention is rendered as plain text. Safe by
 * default — no HTML injection.
 */
export default function MentionText({ text, className = "" }) {
  if (!text) return null;
  const parts = [];
  let lastIndex = 0;
  let match;
  // Use a fresh RegExp every render so the lastIndex state isn't shared
  const re = new RegExp(MENTION_RE.source, "g");
  while ((match = re.exec(text)) !== null) {
    const [whole, lead, handle] = match;
    const start = match.index + lead.length;
    if (start > lastIndex) {
      parts.push(text.slice(lastIndex, start));
    }
    parts.push(
      <Link
        key={`m-${start}`}
        to={`/u/${handle}`}
        onClick={(e) => e.stopPropagation()}
        className="text-[#a78bfa] hover:text-white hover:underline transition-colors"
      >
        @{handle}
      </Link>,
    );
    lastIndex = match.index + whole.length;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return <span className={className}>{parts}</span>;
}
